"use client"

import React from 'react';
import { motion } from 'framer-motion';

interface ServiceButtonProps {
  text: string;
  href: string;
  isPrimary?: boolean;
  className?: string;
}

const ServiceButton = ({ text, href, isPrimary = true, className = '' }: ServiceButtonProps) => {
  return (
    <motion.a 
      href={href} 
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      className={`px-8 py-4 text-center font-extrabold text-lg tracking-wide rounded-lg shadow-lg transition-all ${
        isPrimary 
          ? 'bg-blue-600 hover:bg-blue-700 text-white hover:shadow-blue-500/30 hover:shadow-xl' 
          : 'bg-gray-100 hover:bg-gray-200 text-gray-800 dark:bg-gray-800 dark:hover:bg-gray-700 dark:text-white'
      } ${className}`}
      style={{
        textShadow: isPrimary ? '0 1px 2px rgba(0,0,0,0.2)' : 'none',
        color: isPrimary ? '#ffffff' : ''
      }}
    >
      {text}
    </motion.a>
  );
};

export default ServiceButton; 